import { SERVICE_PROVIDERS } from '@/config/tenants/global';

export const subscriptionTier_options = {
  [SERVICE_PROVIDERS.EM]: [
    { label: 'Fleet Xpress', value: 'STANDARD' },
    { label: 'Xtreme', value: 'PRO' },
  ],
  [SERVICE_PROVIDERS.TP]: [
    { label: 'Professional', value: 'LITE' },
    { label: 'Deluxe', value: 'STANDARD' },
    { label: 'Fleet', value: 'PRO' },
  ],
  default: [
    { label: 'Prime8 ELD', value: 'LITE' },
    { label: 'Fleet Xpress', value: 'STANDARD' },
    { label: 'Xtreme', value: 'PRO' },
  ],
};
